import { useLayoutEffect, useState } from 'react';

/** will calculate if element is overlowing, triggers recalulation by deps */
export const useIsOverflow = (
  ref: React.RefObject<HTMLElement>,
  deps: React.DependencyList = [],
) => {
  const [isOverflow, setIsOverflow] = useState(false);

  useLayoutEffect(() => {
    if (ref.current) {
      setIsOverflow(ref.current.scrollHeight > ref.current.clientHeight);
    }
  }, deps);

  return isOverflow;
};
